export default {
    state:{
        heroInFo:{}
    },
    mutations: {
        heroinfo(state,item){
            state.heroInFo=item
        }
    }
}